import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  Pagination,
} from "react-bootstrap";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./footer";
import logo from "../image/hifi.png";
import walletImg from "../image/walleticon.png";
import iconMembers from "../image/Vector.png";
import iconBag from "../image/Total Member Icon.png";
import iconGrowth from "../image/Growth Icon.png";
import { ethers } from 'ethers';
import showToast from '../components/TopToaster';
import { getData, loginUser } from "../api/protectedApi";
import { useAuth } from "../context/AuthContext";
const ConnectWallet = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [walletAddress, setWalletAddress] = useState('');
  const [userId, setUserId] = useState('');
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);



  // const [showToast, setShowToast] = useState(false);
  const connectWallet = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        // Request account access if needed
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const account = accounts[0];
        setWalletAddress(account);

        // You can now use this provider with ethers
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        showToast('Connected Account:' + account, 'success');
        console.log('Connected Account:', account);
        console.log('Signer:', signer);

        const response = await loginUser({ username: account });
        console.log('response ', response)
        if (response.status === false) {

          showToast(response.message, 'error');
        } else {

          localStorage.setItem('user', JSON.stringify(response));
          login(response.access_token)
          navigate("/dashboard");
          showToast(response.message, 'success');
        }

      } catch (error) {
        console.log('e e e', error)
        showToast('User rejected connection or other error:', 'error');
      }
    } else {
      showToast('No Ethereum wallet found. Please install MetaMask or Trust Wallet.', 'error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {

      const response = await loginUser({ username: userId });
      console.log('response ', response)
      if (response.status === false) {

        showToast(response.message, 'error');
      } else {

        localStorage.setItem('user', JSON.stringify(response));
        login(response.access_token)
        navigate("/dashboard");
        showToast(response.message, 'success');
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setLoading(false);
    }
  };
  const [stats, setStats] = useState({
    total_member_received: 0,
    total_members: 0,
    turnover_usdt: 0,
  });


  const fetchMembers = async (page = 1) => {
    try {
      setLoading(true);
      const response = await getData(`/latest_members?page=${page}`);

      if (response?.data?.data) {
        setMembers(response.data.data);
      } else {
        setMembers([]);
      }

      if (response?.data?.pagination) {
        setStats({
          total_member_received: response.data.pagination.total_member_received,
          total_members: response.data.pagination.total_members,
          turnover_usdt: response.data.pagination.turnover_usdt,
        });

        setCurrentPage(response.data.pagination.current_page);
        setTotalPages(response.data.pagination.total_pages);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchMembers(1);
  }, []);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchMembers(page);
    }
  };
  const getVisiblePages = () => {
    const pages = [];
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };




  return (
    <div style={{ backgroundColor: "#0d0e13", minHeight: "100vh" }}>
      {/* Top Bar */}
      <div className="container-fluid pt-3">
        <nav
          className="custom-navbar d-flex align-items-center justify-content-between"
        >
          {/* <!-- Logo --> */}
          <div className="logo">
            <img src={logo} alt="Logo" />
          </div>

          {/* <!-- Right Menu --> */}
          <Link to="/register" className="d-flex align-items-center text-decoration-none">
            {/* <button className="connect-wallet-btn ">Connect Wallet</button> */}
            <button className="connect-wallet-btn ">Register</button>

          </Link>
          {/* <div class="d-flex align-items-center">
        <a href="register.html" > <button class="connect-wallet-btn">Connect Wallet</button></a>
        </div> */}
        </nav>
      </div>

      {/* Breadcrumb */}
      {/* <TopToaster
        message="Your changes were saved successfully!"
        type="success"
        show={showToast}
      /> */}
      {/* Hero Section */}
      <Container className="text-center mt-5 px-3">
        <img
          src={logo}
          alt="wallet"
          style={{ width: "120px", marginBottom: "30px" }}
        />
        <h2 className="fw-bold text-white">Welcome to Hifi Internationals</h2>
        <p className="text-white-50">
          Connect your wallet to start working. First time here?
          <br />
          Watch a tutorial to learn more.
        </p>
        <Button
          style={{
            backgroundColor: "#a88756",
            color: "#000",
            fontWeight: 600,
            padding: "10px 30px",
            border: "none",
            borderRadius: "8px",
          }}
          onClick={connectWallet}
        >
          Connect Wallet
        </Button>
      </Container>

      {/* Account Preview */}
      <div className="mt-5 py-5" style={{ backgroundColor: "#0d0e13" }}>
        <Container>
          <h3 className="text-white mb-2">Account Preview</h3>
          <p className="text-white-50">
            Look up any Hifi Internationals USDT member account in preview mode. Enter ID or
            USDT address to preview or click Demo to view a random account.
          </p>
          {walletAddress && <p>Connected Wallet: {walletAddress}</p>}
          <Row className="g-3 align-items-center mt-4">
            <Col xs={12} md={8}>
              <form onSubmit={handleSubmit}>
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder="Enter any ID here"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    style={{
                      backgroundColor: "#1b1f1b",
                      border: "1px solid #333",
                      color: "#fff",
                    }}
                  />
                  <Button
                    style={{
                      backgroundColor: "#a88756",
                      color: "#000",
                      fontWeight: "600",
                      border: "none",
                    }}
                    disabled={loading}
                    type="submit"
                  >
                    {loading ? "Checking In..." : "Submit"}
                  </Button>
                </InputGroup>
              </form>
            </Col>

            <Col xs={12} md={4}>
              <div
                className="p-3 rounded text-center mt-2 mt-md-0"
                style={{ backgroundColor: "#0d0e13", color: "#fff" }}
              >
                <p className="mb-2 text-white-50">Let’s begin with Demo</p>
                <Button
                  variant="outline-success"
                  style={{ borderColor: "#a88756", color: "#fff" }}
                >
                  Check Demo
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>


      {/* Transaction Table & Stats */}
      <Container className="py-5">
        <Row>
          {/* Transactions */}
          <Col xs={12} md={8} className="mb-4 mb-md-0">
            <div className="rounded p-3" style={{ backgroundColor: "#141245" }}>
              <section className="landing-6 py-5">
                <div className="container">
                  <div className="table-card p-4">
                    <h5 className="text-center mb-4 race-title">
                      Hifi Members
                    </h5>

                    <div className="table-responsive">
                      <table className="table table-borderless align-middle landing-table">
                        <thead>
                          <tr>
                            <th>S No</th>
                            <th>User id</th>
                            <th>Eth_address</th>
                            <th>package_amount</th>
                            <th>Created</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="5" className="text-center text-white">
                                Loading...
                              </td>
                            </tr>
                          ) : members.length === 0 ? (
                            <tr>
                              <td colSpan="5" className="text-center text-white">
                                No members found
                              </td>
                            </tr>
                          ) : (
                            members.map((item, index) => (
                              <tr key={index}>
                                <td>{(currentPage - 1) * perPage + index + 1}</td>
                                <td>{item.user_id}</td>
                                <td>{item.eth_address}</td>
                                <td>{item.package_amount}</td>
                                <td>{item.created_at}</td>
                                <td
                                  className={`status ${item.status === "approved"
                                    ? "approved"
                                    : "pending"
                                    }`}
                                >
                                  {item.status}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination placeholder (optional later) */}
                  </div>
                </div>
              </section>
              <Pagination className="justify-content-center mt-3 mb-0">

                <Pagination.Prev
                  disabled={currentPage === 1}
                  onClick={() => fetchMembers(currentPage - 1)}
                />

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => fetchMembers(page)}
                  >
                    {page}
                  </Pagination.Item>
                ))}

                <Pagination.Next
                  disabled={currentPage === totalPages}
                  onClick={() => fetchMembers(currentPage + 1)}
                />

              </Pagination>


            </div>
          </Col>

          {/* Stats */}
          <Col xs={12} md={4}>
            {[
              {
                label: "Members Received",
                value: stats.total_member_received,
                icon: iconMembers,
              },
              {
                label: "Total Members",
                value: stats.total_members,
                icon: iconBag,
              },
              {
                label: "Turnover, USDT",
                value: stats.turnover_usdt,
                icon: iconGrowth,
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="p-3 mb-3 d-flex align-items-center justify-content-between rounded"
                style={{ backgroundColor: "#141245" }}
              >
                <div>
                  <small className="text-white-50">{item.label}</small>
                  <h5 className="mb-0 text-white">{item.value}</h5>
                </div>
                <img src={item.icon} alt="Icon" style={{ height: "40px" }} />
              </div>
            ))}
          </Col>

        </Row>
      </Container>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ConnectWallet;
